import { DUBAI_TZ, PAGE_SIZE_OPTIONS, TIME_AND_DATE_FORMATS } from '@app/constants';
import dayjs from 'dayjs';
const timeZoneOffset = +4;

export const timeFormatter = (interval: number, format: string) => {
  return dayjs(interval).format(format);
};

export const intervalFormatter = (interval: number) => {
  return dayjs(interval)
    .utcOffset(timeZoneOffset)
    .format(TIME_AND_DATE_FORMATS.DAY_MONTH_DATE_YEAR_TIME_SHORTED_FORMAT);
};

export const calcGradientMiddleColor = ({
  color1,
  color2,
  ratio
}: {
  color1: string;
  color2: string;
  ratio: number;
}) => {
  const hex = color => {
    const colorString = color.toString(16);
    return colorString.length === 1 ? `0${colorString}` : colorString;
  };

  const r = Math.ceil(
    parseInt(color2.substring(0, 2), 16) * ratio + parseInt(color1.substring(0, 2), 16) * (1 - ratio)
  );
  const g = Math.ceil(
    parseInt(color2.substring(2, 4), 16) * ratio + parseInt(color1.substring(2, 4), 16) * (1 - ratio)
  );
  const b = Math.ceil(
    parseInt(color2.substring(4, 6), 16) * ratio + parseInt(color1.substring(4, 6), 16) * (1 - ratio)
  );

  return hex(r) + hex(g) + hex(b);
};

export const toStringTimeFormatter = (date: number | string) => {
  return dayjs(date).format('YYYY-MM-DD');
};

export const convertCronStructure = (cron: Array<string> | { [key: string]: string }) => {
  if (Array.isArray(cron)) {
    return cron.reduce((acc, item, index) => {
      acc[index] = item;
      return acc;
    }, {});
  }

  return Object.values(cron);
};

export const generateDefaultTablePagination = ({
  page,
  limit,
  total
}: {
  page: number;
  limit: number;
  total?: number;
}) => {
  return {
    position: ['bottomRight'],
    size: 'default',
    current: page,
    total,
    defaultPageSize: limit,
    showTotal: (totalAmount: number, range: number[]) => `${range[0]}-${range[1]} of ${totalAmount} items`,
    showSizeChanger: true,
    pageSizeOptions: PAGE_SIZE_OPTIONS
  };
};

export const isUnitOld = (lastActiveAt: number) =>
  dayjs(Date.now()).utcOffset(DUBAI_TZ).diff(lastActiveAt, 'minutes', true) > 30;

export const parseJwtToken = token => {
  try {
    if (!token) {
      return { isExpired: true, expiresAt: null };
    }

    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT token format');
    }

    const payload = parts[1];
    const paddedPayload = payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');
    const decodedPayload = atob(paddedPayload.replace(/-/g, '+').replace(/_/g, '/'));
    const claims = JSON.parse(decodedPayload);

    const expiresAt = claims.exp * 1000;
    const currentTime = Date.now();
    const isExpired = currentTime >= expiresAt;

    const tokenInfo = {
      isExpired,
      expiresAt,
      expiresIn: expiresAt - currentTime // Milliseconds until expiration
    };

    return tokenInfo;
  } catch (error) {
    console.error('Error parsing JWT token:', error);
    return { isExpired: true, expiresAt: null };
  }
};
